export const GRID_PAGE_SIZE = 24;
export const COMPACT_GRID_PAGE_SIZE = 12;
